import React from "react";
import { PrivacyPage } from "@v2/components/policies/privacy";

export default function PrivacyPolicy() {
    return <PrivacyPage />;
}
